export interface RegisterUserAskRequest {
    username: string;
    email: string;
    organization_code: number;
    country: string;
    simple_date_format: string;
    separator: string;
    four_digit_year: boolean;
    password: string;
    teams?: number[];
}

export class RegisterBasicUser {
    private readonly username: string;
    private readonly emailAddress: string;
    private readonly password: string;

    constructor(username: string, emailAddress: string, password: string) {
        this.username = username;
        this.emailAddress = emailAddress;
        this.password = password;
    }

    createRequestBody(): Pick<RegisterUserAskRequest, 'username' | 'email' | 'password'> {
        return {
            username: this.username,
            email: this.emailAddress,
            password: this.password,
        };
    }
}

export class RegisterData {
    private readonly registerBasicUser: RegisterBasicUser;
    private readonly organization: number;
    private readonly country: string;
    private readonly format: string;
    private readonly separator: string;
    private readonly fourDigitYear: boolean;
    private readonly teams: number[];


    constructor(registerBasicUser: RegisterBasicUser, organization: number, country: string,
                format: string, separator: string, fourDigitYear: boolean, teams: number[]
    ) {
        this.registerBasicUser = registerBasicUser;
        this.organization = organization;
        this.country = country;
        this.format = format;
        this.separator = separator;
        this.fourDigitYear = fourDigitYear;
        this.teams = teams;
    }

    createRequestBody(): RegisterUserAskRequest {
        const body: RegisterUserAskRequest = {
            ...this.registerBasicUser.createRequestBody(),
            organization_code: Number(this.organization),
            country: this.country,
            simple_date_format: this.format,
            separator: this.separator,
            four_digit_year: Boolean(this.fourDigitYear),
        };
        if (this.teams.length > 0) {
            body.teams = this.teams.map((team: number) => Number(team));
        }
        return body;
    }
}
